(function () {
  function slug(s) {
    return s.toLowerCase().replace(/&amp;/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }

  function buildToc() {
    var toc = document.querySelector('[data-hh-toc]');
    var body = document.querySelector('.hh-post__body');
    if (!toc || !body) return;
    var heads = body.querySelectorAll('h2, h3');
    var h2count = body.querySelectorAll('h2').length;
    if (h2count < 3) return;
    var list = toc.querySelector('.hh-toc__list');
    var used = {};
    var currentSub = null;
    heads.forEach(function (h) {
      var text = h.textContent.trim();
      if (!text) return;
      if (!h.id) {
        var id = slug(text) || 'section';
        while (used[id] || document.getElementById(id)) id += '-2';
        h.id = id;
      }
      used[h.id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      if (h.tagName === 'H2') {
        list.appendChild(li);
        currentSub = null;
        list._last = li;
      } else if (list._last && !h.closest('.hh-pcard')) {
        if (!currentSub) {
          currentSub = document.createElement('ol');
          list._last.appendChild(currentSub);
        }
        currentSub.appendChild(li);
      }
    });
    toc.hidden = false;
    if (window.matchMedia('(max-width: 749px)').matches) toc.open = false;
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function refreshPrices() {
    var cards = document.querySelectorAll('.hh-pcard[data-handle]');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var price = card.querySelector('.hh-pcard__price');
          if (price) price.textContent = (p.price_varies ? 'from ' : '') + money(p.price_min);
          if (!p.available) {
            var btn = card.querySelector('.hh-pcard__btn');
            if (btn) btn.firstChild.textContent = 'Sold out ';
          }
        })
        .catch(function () {});
    });
  }

  function copyLinks() {
    document.querySelectorAll('[data-hh-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var done = btn.querySelector('.hh-share__done');
        var url = btn.getAttribute('data-hh-copy');
        (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
          if (!done) return;
          done.hidden = false;
          setTimeout(function () { done.hidden = true; }, 1600);
        }).catch(function () { window.prompt('Copy link', url); });
      });
    });
  }

  function init() { buildToc(); refreshPrices(); copyLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
